module.exports = __webpack_public_path__ + "static/RR0-d5e7a3907041702b97b09747ede4727d.jpg";